export const productOfferingTypes = {
  performance: 'performance',
  engagement: 'engagement',
  goals: 'goals',
}
